import heydoctor from 'app/vendor/heydoctor';
import { sessionStorage } from 'app/lib/storage';
import { isClient } from 'app/lib/utils';
import { Stores, Store } from 'app/lib/synaptik';

interface State {
  states: string[];
  fetchingList?: boolean;
}

export class BusinessStore extends Store<State, Stores> {
  state: State = {
    states: [],
  };

  constructor(...args: [any, any]) {
    super(...args);

    if (isClient()) {
      const states = sessionStorage.get('hd.states');

      if (states) {
        this.state.states = states;
      }
    }
  }

  fetchAvailableStates = () =>
    this.runAsync({
      key: 'fetchingList',
      work: async () => {
        const states = await heydoctor.business.fetchAvailableStates();

        sessionStorage.set('hd.states', states);

        this.setState({
          states,
        });

        return states;
      },
    });
}
